// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"caa389a3","488":"c1fc0aa9","977":"c2184f84"}[chunkId] + ".chunk.js";
};